export default __webpack_public_path__ + "static/media/KnackSpinner.d2cb7831.svg";